import { isTimeAfter, isTimeBefore } from '@library/utils/dateTime';
import type { DateTime } from 'luxon';
import { isEmpty } from 'ramda';

const REGEX = {
  HOUR: /^(1[0-2]|0?[1-9])$/,
  MINUTE: /^[0-5]?\d$/
};

export const isValidHour = (hourString?: string): boolean => {
  return !!hourString && !isEmpty(hourString) && REGEX.HOUR.test(hourString);
};

export const isValidMinute = (minuteString?: string): boolean => {
  return (
    !!minuteString && !isEmpty(minuteString) && REGEX.MINUTE.test(minuteString)
  );
};

export const isBeforeMinTime = ({
  minDate,
  newTime
}: {
  minDate?: DateTime;
  newTime: DateTime;
}) =>
  minDate &&
  isTimeBefore({ dateValue: newTime, dateToCompareAgainst: minDate });

export const isAfterMaxTime = ({
  maxDate,
  newTime
}: {
  maxDate?: DateTime;
  newTime: DateTime;
}) =>
  maxDate && isTimeAfter({ dateValue: newTime, dateToCompareAgainst: maxDate });

// Validates if date is in the format MM-DD-YYYY
export const isValidShortDateFormat = (value: string) => {
  const dateRegex = /^(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])-\d{4}$/;
  return dateRegex.test(value);
};

// Validates if date is in the format YYYY-MM-DD
export const isValidYearMonthDayFormat = (value: string) => {
  const dateRegex = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])$/;
  return dateRegex.test(value);
};

// Converts date to YYYY-MM-DD format
export const convertToYearMonthDayFormat = (date: string): string => {
  if (!isValidShortDateFormat(date)) {
    return '';
  }

  const dateRegex = /^(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])-(\d{4})$/;
  const match = dateRegex.exec(date);

  if (match) {
    const [, month, day, year] = match;
    return `${year}-${month}-${day}`;
  }

  return date;
};

export const convertToMonthDayYearFormat = (date: string): string => {
  if (!isValidYearMonthDayFormat(date)) {
    return '';
  }

  const dateRegex = /^(\d{4})-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])$/;
  const match = dateRegex.exec(date);

  if (match) {
    const [, year, month, day] = match;
    return `${month}-${day}-${year}`;
  }

  return date;
};
